import { useIntl } from 'react-intl';

import type { Props as ButtonProps } from '#src/atoms/buttons/Button/index.tsx';
import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { iconChevronLeft } from '#src/atoms/icons/system/iconChevronLeft.ts';
import { glossary } from '#src/lib/glossary.ts';

type Props = {
  onBack: () => void;
  color?: ButtonProps['color'];
};

export const BackButton = ({ onBack, color = 'tertiary' }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <IconButton
      size="medium"
      onClick={onBack}
      icon={iconChevronLeft}
      color={color}
      aria-label={formatMessage(glossary.back)}
    />
  );
};
